import { isStorageSelectable, storageOptionLabel } from '../utils/storageSelectable';   // 687
import React from 'react';
import { ITEM_CATEGORY_LABELS, useCategoryConstants } from '../config/categoryConstants';
import { labelFor } from '../utils/labels';

// Sibling of ItemOptgroups / AccountOptgroups: renders storages (and bird bands) as a constant-grouped
// tree inside a native <select>. Storages group by their constant_key; BANDS are the birds' location, so
// they render under the 'birds' constant group. Band option values are prefixed 'band:' so the caller can
// route the pick to band_id vs storage_id (see sideValue/onChange in the forms). This ONLY groups+labels —
// it never adds/removes a node, so it stays money-neutral and leaves any gating to the caller.
//
//   Level 1  Constant (category_constants display_label, live) -> <optgroup label>
//   Level 2  Storage / Band name                               -> selectable <option>

const IND = '  ';   // level-2 indent (nbsp — options strip real spaces)

export const BAND_PREFIX = 'band:';

export default function StorageOptgroups({ storages = [], bands = [] }) {
  useCategoryConstants();   // re-render when the live constant display_labels hydrate

  const byConstant = {};   // constant_key -> { label, nodes: [{ value, name }] }
  const push = (cat, node) => {
    const c = String(cat || '').toLowerCase();
    if (!byConstant[c]) byConstant[c] = { label: labelFor(ITEM_CATEGORY_LABELS, c), nodes: [] };
    byConstant[c].nodes.push(node);
  };
  // 687: a storage only reaches this list while dormant when it is the line's BOUND one
  // (selectableStorages' alwaysShowId). Carry its reason and disable it, so it is visible as the
  // current destination but cannot be re-picked — same treatment as the plain <select> pickers.
  for (const s of storages) push(s.constant_key, { value: s.id, name: storageOptionLabel(s), disabled: !isStorageSelectable(s) });
  for (const b of bands)    push('birds',        { value: BAND_PREFIX + b.id, name: b.name });

  const constOrder = Object.keys(ITEM_CATEGORY_LABELS);
  const rank = c => { const i = constOrder.indexOf(c); return i < 0 ? 999 : i; };
  const cats = Object.keys(byConstant).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));

  return (
    <>
      {cats.map(cat => (
        <optgroup key={cat} label={byConstant[cat].label}>
          {byConstant[cat].nodes
            .slice()
            .sort((x, y) => x.name.localeCompare(y.name))
            .map(n => <option key={n.value} value={n.value} disabled={!!n.disabled}>{IND}{n.name}</option>)}
        </optgroup>
      ))}
    </>
  );
}
